"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalTrainerApi = exports.PersonalTrainerApiFactory = exports.PersonalTrainerApiFp = exports.PersonalTrainerApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * PersonalTrainerApi - axios parameter creator
 * @export
 */
const PersonalTrainerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: GetMyStatistics - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Bir kişisel antrenörün kendi istatistik bilgilerini getirmesini sağlar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyStatistics: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer/get_my_statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: GetPublicPersonalTrainerDetails - Difficulty: 3 - Roles can execute: everybody
         * @summary Kişisel antrenörün herkese açık detaylarını getirir.
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicPersonalTrainerDetails: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getPublicPersonalTrainerDetails', 'id', id);
            const localVarPath = `/api/personal_trainer/get_public_personal_trainer_details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: GetStatisticsOfPersonalTrainer - Difficulty: 3 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_CUSTOMER
         * @summary Giriş yapmış bir hesabın bir kişisel antrenörün istatistik bilgilerini getirmesini sağlar.
         * @param {number} personalTrainerMetadataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsOfPersonalTrainer: (personalTrainerMetadataId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personalTrainerMetadataId' is not null or undefined
            (0, common_1.assertParamExists)('getStatisticsOfPersonalTrainer', 'personalTrainerMetadataId', personalTrainerMetadataId);
            const localVarPath = `/api/personal_trainer/get_statistics_of_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (personalTrainerMetadataId !== undefined) {
                localVarQueryParameter['personalTrainerMetadataId'] = personalTrainerMetadataId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ListMyBroadcastFixture - Difficulty: 5 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Kişisel antrenörün kendi yayın fikstürünü listelemesini sağlar. Başlangıç tarihine göre ASC sıralanması gerekiyor. Geçmiş yayınlar gösterilmez.
         * @param {string} targetDay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyBroadcastFixture: (targetDay, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'targetDay' is not null or undefined
            (0, common_1.assertParamExists)('listMyBroadcastFixture', 'targetDay', targetDay);
            const localVarPath = `/api/personal_trainer/list_my_broadcast_fixture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (targetDay !== undefined) {
                localVarQueryParameter['targetDay'] = (targetDay instanceof Date) ?
                    targetDay.toISOString().substr(0, 10) :
                    targetDay;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ListPersonalTrainerActivities - Difficulty: 2 - Roles can execute: everybody
         * @summary Kişisel antrenörün etkinliklerini herkesin görebileceği bir şekilde listeler. id alanına göre DESC olarak sıralanmalıdır.
         * @param {number} personalTrainerMetadataId
         * @param {number} [lastActivityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainerActivities: (personalTrainerMetadataId, lastActivityId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personalTrainerMetadataId' is not null or undefined
            (0, common_1.assertParamExists)('listPersonalTrainerActivities', 'personalTrainerMetadataId', personalTrainerMetadataId);
            const localVarPath = `/api/personal_trainer/list_personal_trainer_activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lastActivityId !== undefined) {
                localVarQueryParameter['lastActivityId'] = lastActivityId;
            }
            if (personalTrainerMetadataId !== undefined) {
                localVarQueryParameter['personalTrainerMetadataId'] = personalTrainerMetadataId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ListPersonalTrainers - Difficulty: 4 - Roles can execute: everybody
         * @summary Kişisel antrenör listelemesi ve araması için kullanılır. Sayfa başına 50 adet kayıt dönmelidir. Kayıtlar PersonalTrainerMetadata tablosundaki id kolonuna göre tersten (DESC) sıralanmalıdır. Query parametresi, kişisel antrenörün ismine göre arama için kullanılır. (Bilgi: Postgresql\'de LIKE sorgusu case sensitive çalışmaktadır. Bu sebeple ILIKE (Incasesensitive like) fonksiyonu kullanılabilir).
         * @param {number} [idOfLastPersonalTrainerItem]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainers: (idOfLastPersonalTrainerItem, query, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer/list_personal_trainers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (idOfLastPersonalTrainerItem !== undefined) {
                localVarQueryParameter['idOfLastPersonalTrainerItem'] = idOfLastPersonalTrainerItem;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateMyDescription - Difficulty: 1 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Bir kişisel antrenörün kendi tanıtım yazısını güncellemesini sağlar.
         * @param {UpdateMyDescriptionCommand} [updateMyDescriptionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyDescription: (updateMyDescriptionCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer/update_my_description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateMyDescriptionCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PersonalTrainerApiAxiosParamCreator = PersonalTrainerApiAxiosParamCreator;
/**
 * PersonalTrainerApi - functional programming interface
 * @export
 */
const PersonalTrainerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PersonalTrainerApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: GetMyStatistics - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Bir kişisel antrenörün kendi istatistik bilgilerini getirmesini sağlar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyStatistics(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyStatistics(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: GetPublicPersonalTrainerDetails - Difficulty: 3 - Roles can execute: everybody
         * @summary Kişisel antrenörün herkese açık detaylarını getirir.
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicPersonalTrainerDetails(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPublicPersonalTrainerDetails(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: GetStatisticsOfPersonalTrainer - Difficulty: 3 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_CUSTOMER
         * @summary Giriş yapmış bir hesabın bir kişisel antrenörün istatistik bilgilerini getirmesini sağlar.
         * @param {number} personalTrainerMetadataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsOfPersonalTrainer(personalTrainerMetadataId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStatisticsOfPersonalTrainer(personalTrainerMetadataId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ListMyBroadcastFixture - Difficulty: 5 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Kişisel antrenörün kendi yayın fikstürünü listelemesini sağlar. Başlangıç tarihine göre ASC sıralanması gerekiyor. Geçmiş yayınlar gösterilmez.
         * @param {string} targetDay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyBroadcastFixture(targetDay, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMyBroadcastFixture(targetDay, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ListPersonalTrainerActivities - Difficulty: 2 - Roles can execute: everybody
         * @summary Kişisel antrenörün etkinliklerini herkesin görebileceği bir şekilde listeler. id alanına göre DESC olarak sıralanmalıdır.
         * @param {number} personalTrainerMetadataId
         * @param {number} [lastActivityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainerActivities(personalTrainerMetadataId, lastActivityId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPersonalTrainerActivities(personalTrainerMetadataId, lastActivityId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ListPersonalTrainers - Difficulty: 4 - Roles can execute: everybody
         * @summary Kişisel antrenör listelemesi ve araması için kullanılır. Sayfa başına 50 adet kayıt dönmelidir. Kayıtlar PersonalTrainerMetadata tablosundaki id kolonuna göre tersten (DESC) sıralanmalıdır. Query parametresi, kişisel antrenörün ismine göre arama için kullanılır. (Bilgi: Postgresql\'de LIKE sorgusu case sensitive çalışmaktadır. Bu sebeple ILIKE (Incasesensitive like) fonksiyonu kullanılabilir).
         * @param {number} [idOfLastPersonalTrainerItem]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainers(idOfLastPersonalTrainerItem, query, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPersonalTrainers(idOfLastPersonalTrainerItem, query, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateMyDescription - Difficulty: 1 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Bir kişisel antrenörün kendi tanıtım yazısını güncellemesini sağlar.
         * @param {UpdateMyDescriptionCommand} [updateMyDescriptionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyDescription(updateMyDescriptionCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMyDescription(updateMyDescriptionCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PersonalTrainerApiFp = PersonalTrainerApiFp;
/**
 * PersonalTrainerApi - factory interface
 * @export
 */
const PersonalTrainerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PersonalTrainerApiFp)(configuration);
    return {
        /**
         * Operation Id: GetMyStatistics - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Bir kişisel antrenörün kendi istatistik bilgilerini getirmesini sağlar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyStatistics(options) {
            return localVarFp.getMyStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: GetPublicPersonalTrainerDetails - Difficulty: 3 - Roles can execute: everybody
         * @summary Kişisel antrenörün herkese açık detaylarını getirir.
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicPersonalTrainerDetails(id, options) {
            return localVarFp.getPublicPersonalTrainerDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: GetStatisticsOfPersonalTrainer - Difficulty: 3 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_CUSTOMER
         * @summary Giriş yapmış bir hesabın bir kişisel antrenörün istatistik bilgilerini getirmesini sağlar.
         * @param {number} personalTrainerMetadataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsOfPersonalTrainer(personalTrainerMetadataId, options) {
            return localVarFp.getStatisticsOfPersonalTrainer(personalTrainerMetadataId, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ListMyBroadcastFixture - Difficulty: 5 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Kişisel antrenörün kendi yayın fikstürünü listelemesini sağlar. Başlangıç tarihine göre ASC sıralanması gerekiyor. Geçmiş yayınlar gösterilmez.
         * @param {string} targetDay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyBroadcastFixture(targetDay, options) {
            return localVarFp.listMyBroadcastFixture(targetDay, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ListPersonalTrainerActivities - Difficulty: 2 - Roles can execute: everybody
         * @summary Kişisel antrenörün etkinliklerini herkesin görebileceği bir şekilde listeler. id alanına göre DESC olarak sıralanmalıdır.
         * @param {number} personalTrainerMetadataId
         * @param {number} [lastActivityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainerActivities(personalTrainerMetadataId, lastActivityId, options) {
            return localVarFp.listPersonalTrainerActivities(personalTrainerMetadataId, lastActivityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ListPersonalTrainers - Difficulty: 4 - Roles can execute: everybody
         * @summary Kişisel antrenör listelemesi ve araması için kullanılır. Sayfa başına 50 adet kayıt dönmelidir. Kayıtlar PersonalTrainerMetadata tablosundaki id kolonuna göre tersten (DESC) sıralanmalıdır. Query parametresi, kişisel antrenörün ismine göre arama için kullanılır. (Bilgi: Postgresql\'de LIKE sorgusu case sensitive çalışmaktadır. Bu sebeple ILIKE (Incasesensitive like) fonksiyonu kullanılabilir).
         * @param {number} [idOfLastPersonalTrainerItem]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainers(idOfLastPersonalTrainerItem, query, options) {
            return localVarFp.listPersonalTrainers(idOfLastPersonalTrainerItem, query, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateMyDescription - Difficulty: 1 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Bir kişisel antrenörün kendi tanıtım yazısını güncellemesini sağlar.
         * @param {UpdateMyDescriptionCommand} [updateMyDescriptionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyDescription(updateMyDescriptionCommand, options) {
            return localVarFp.updateMyDescription(updateMyDescriptionCommand, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PersonalTrainerApiFactory = PersonalTrainerApiFactory;
/**
 * PersonalTrainerApi - object-oriented interface
 * @export
 * @class PersonalTrainerApi
 * @extends {BaseAPI}
 */
class PersonalTrainerApi extends base_1.BaseAPI {
    /**
     * Operation Id: GetMyStatistics - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
     * @summary Bir kişisel antrenörün kendi istatistik bilgilerini getirmesini sağlar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerApi
     */
    getMyStatistics(options) {
        return (0, exports.PersonalTrainerApiFp)(this.configuration).getMyStatistics(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: GetPublicPersonalTrainerDetails - Difficulty: 3 - Roles can execute: everybody
     * @summary Kişisel antrenörün herkese açık detaylarını getirir.
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerApi
     */
    getPublicPersonalTrainerDetails(id, options) {
        return (0, exports.PersonalTrainerApiFp)(this.configuration).getPublicPersonalTrainerDetails(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: GetStatisticsOfPersonalTrainer - Difficulty: 3 - Roles can execute: ROLE_PERSONAL_TRAINER, ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_CUSTOMER
     * @summary Giriş yapmış bir hesabın bir kişisel antrenörün istatistik bilgilerini getirmesini sağlar.
     * @param {number} personalTrainerMetadataId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerApi
     */
    getStatisticsOfPersonalTrainer(personalTrainerMetadataId, options) {
        return (0, exports.PersonalTrainerApiFp)(this.configuration).getStatisticsOfPersonalTrainer(personalTrainerMetadataId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ListMyBroadcastFixture - Difficulty: 5 - Roles can execute: ROLE_PERSONAL_TRAINER
     * @summary Kişisel antrenörün kendi yayın fikstürünü listelemesini sağlar. Başlangıç tarihine göre ASC sıralanması gerekiyor. Geçmiş yayınlar gösterilmez.
     * @param {string} targetDay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerApi
     */
    listMyBroadcastFixture(targetDay, options) {
        return (0, exports.PersonalTrainerApiFp)(this.configuration).listMyBroadcastFixture(targetDay, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ListPersonalTrainerActivities - Difficulty: 2 - Roles can execute: everybody
     * @summary Kişisel antrenörün etkinliklerini herkesin görebileceği bir şekilde listeler. id alanına göre DESC olarak sıralanmalıdır.
     * @param {number} personalTrainerMetadataId
     * @param {number} [lastActivityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerApi
     */
    listPersonalTrainerActivities(personalTrainerMetadataId, lastActivityId, options) {
        return (0, exports.PersonalTrainerApiFp)(this.configuration).listPersonalTrainerActivities(personalTrainerMetadataId, lastActivityId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ListPersonalTrainers - Difficulty: 4 - Roles can execute: everybody
     * @summary Kişisel antrenör listelemesi ve araması için kullanılır. Sayfa başına 50 adet kayıt dönmelidir. Kayıtlar PersonalTrainerMetadata tablosundaki id kolonuna göre tersten (DESC) sıralanmalıdır. Query parametresi, kişisel antrenörün ismine göre arama için kullanılır. (Bilgi: Postgresql\'de LIKE sorgusu case sensitive çalışmaktadır. Bu sebeple ILIKE (Incasesensitive like) fonksiyonu kullanılabilir).
     * @param {number} [idOfLastPersonalTrainerItem]
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerApi
     */
    listPersonalTrainers(idOfLastPersonalTrainerItem, query, options) {
        return (0, exports.PersonalTrainerApiFp)(this.configuration).listPersonalTrainers(idOfLastPersonalTrainerItem, query, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateMyDescription - Difficulty: 1 - Roles can execute: ROLE_PERSONAL_TRAINER
     * @summary Bir kişisel antrenörün kendi tanıtım yazısını güncellemesini sağlar.
     * @param {UpdateMyDescriptionCommand} [updateMyDescriptionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerApi
     */
    updateMyDescription(updateMyDescriptionCommand, options) {
        return (0, exports.PersonalTrainerApiFp)(this.configuration).updateMyDescription(updateMyDescriptionCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PersonalTrainerApi = PersonalTrainerApi;
